<div class="flex flex-row items-center gap-3 px-2">
  <lib-avatars [size]="32" [persons]="[patient] | libPatientsToPersons"></lib-avatars>
  <div class="flex flex-1 flex-col gap-1">
    <div class="flex flex-1 gap-1">
      <span
        class="typo-h4-light"
        libHighlight
        [searchTerm]="highlightedText"
        [text]="patient.firstName"
        [searchForEveryWord]="true"
        classesToApply="bg-states-orange text-text-white"
      ></span>
      <span
        class="typo-h4-semibold"
        libHighlight
        [searchTerm]="highlightedText"
        [text]="patient.lastName"
        [searchForEveryWord]="true"
        classesToApply="bg-states-orange text-text-white"
      ></span>
    </div>
  </div>
</div>
<span class="typo-h4-medium px-2 text-text-primary">{{ (toLocalDate(patient.birthDate) | date: 'MM / dd / yyyy') ?? '-' }}</span>
<lib-patient-status class="px-2" [status]="patient.status!" />
<!-- NOTE: There should be a mobilePhoneExt -->
<span class="typo-h4-medium px-2 text-text-primary">{{ patient.workPhoneExt }} {{ patient.mobilePhone | libPhoneFormat }} </span>
<span
  class="typo-h4-medium px-2 text-text-primary"
  libHighlight
  [searchTerm]="highlightedText"
  [text]="patient.email ?? '-'"
  classesToApply="bg-states-orange text-text-white"
></span>
<lib-patient-item-actions [patientId]="patient.id" />
